import React from "react";
import NumberFormat from "react-number-format";

export const AmountFormatCustom = React.forwardRef(function AmountFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      fixedDecimalScale="true"
      decimalScale="2"
      prefix="$"
    />
  );
});
